import Grid from '@mui/material/Grid';
import Page from 'components/system/Page';
import Paper from 'components/system/Paper';
import usePermissions from 'hooks/usePermissions';
import Typography from '@mui/material/Typography';
import colors from 'styles/colors';
import Container from '@mui/material/Container';
import ActionableBanner from '../ActionableBanner';
import Balance from './Balance';
import UsageChart from './UsageChart';
import PaymentMethod from './PaymentMethod';
import TransactionHistory from './TransactionHistory';
import './payments.css';

const Payments = () => {
  const { hasPermission } = usePermissions();

  return (
    <Container>
      {hasPermission('billing.team.edit') || hasPermission('billing.user')
        ? (
          <Page title="Billing">
            {hasPermission('promo.banner') && <ActionableBanner />}
            <Grid container direction="row" spacing={3}>
              <Grid item md={6} sm={12}>
                <Balance />
              </Grid>
              <Grid item md={6} sm={12}>
                <PaymentMethod />
              </Grid>
              <Grid item xs={12}>
                <UsageChart />
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <TransactionHistory />
              </Grid>
            </Grid>
          </Page>
        ) : (
          <Page title="Billing">
            <Grid container direction="row" spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ paddingTop: '40px', paddingBottom: '40px', textAlign: 'center' }}>
                  <Typography type="h5" color={colors.text.primary}>
                    You do not have access to team billing. Please contact the team admin.
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <UsageChart />
              </Grid>
            </Grid>
          </Page>
        )}
    </Container>
  );
};

export default Payments;
